export default "__VITE_ASSET__5bf64b08__"